/** @format */

import { Box, List, ListItem, Typography } from '@mui/material';
import { map } from 'lodash';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import BookingRequestNotice from 'src/components/notice/booking-request';
import { Scrollbar } from 'src/components/scrollbar';
import { notificationActions } from 'src/config';
import { useBookingRequestAction } from 'src/hooks/use-booking-request-action';

export const RequestList = ({ requests }) => {
  const { handleConfirm } = useBookingRequestAction();

  return (
    <Scrollbar sx={{ maxHeight: 'calc(100vh - 150px)' }}>
      <List disablePadding>
        {map(requests, (request) => (
          <ListItem
            divider
            key={request.id}
            sx={{
              alignItems: 'flex-start',
              wordBreak: 'break-word',
              '&:hover': {
                backgroundColor: 'action.hover'
              },
              '& .MuiListItemSecondaryAction-root': {
                top: '14%'
              }
              // ...(unread && { background: '#deff7a12' })
            }}
            // secondaryAction={
            //   <Tooltip title="Bỏ qua">
            //     <IconButton edge="end" onClick={() => onConfirm?.(request.id)} size="small">
            //       <SvgIcon>
            //         <XIcon />
            //       </SvgIcon>
            //     </IconButton>
            //   </Tooltip>
            // }
          >
            <BookingRequestNotice
              content={request}
              onConfirm={handleConfirm}
              pushAction={notificationActions.BOOKING_REQUEST_WAITING_APPROVAL}
            />
          </ListItem>
        ))}
      </List>
    </Scrollbar>
  );
};

export const RequestAwaitingApproval = ({ requests }) => {
  const isEmpty = requests.length === 0;

  useEffect(() => {
    map(requests, (request) => {
      toast.dismiss(request.id);
    });
  }, [requests]);

  return (
    <>
      {isEmpty ? (
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle2">Dữ liệu trống</Typography>
        </Box>
      ) : (
        <RequestList requests={requests} />
      )}
    </>
  );
};

export default RequestAwaitingApproval;
